// import { getAnalytics } from "firebase/analytics";
import { initializeApp } from "firebase/app";
// Import the functions you need from the SDKs you need
import { getAuth, onAuthStateChanged, updateProfile } from "firebase/auth";
import { useEffect, useState } from "react";
import { getDownloadURL, getStorage, ref, uploadBytes } from "firebase/storage";

const firebaseConfig = {
  apiKey: "AIzaSyC9BDOdwyX7aiJ2ZBhC7HOoYr-lem0T4OY",
  authDomain: "apps-132a6.firebaseapp.com",
  projectId: "apps-132a6",
  storageBucket: "apps-132a6.appspot.com",
  messagingSenderId: "777228065391",
  appId: "1:777228065391:web:dfb39e06bc0de347a58b9a",
  measurementId: "G-BZW44JGM90"
};


// Initialize Firebase
export const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
// firebase.auth().useDeviceLanguage();
// const analytics = getAnalytics(app);
export const storage = getStorage();

// Custom Hook
export function useAuth() {
  const [currentUser, setCurrentUser] = useState();

  useEffect(() => {
    const unsub = onAuthStateChanged(auth, user => setCurrentUser(user));
    return unsub;
  }, [])

  return currentUser;
}

// Storage
export async function upload(file, currentUser, setLoading) {
  const fileRef = ref(storage, currentUser.uid + '.jpg');

  setLoading(true);
  
  const snapshot = await uploadBytes(fileRef, file);
  const photoURL = await getDownloadURL(fileRef);

  updateProfile(currentUser, {photoURL});
  
  setLoading(false);
  alert("Uploaded file");
}